import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchInstructionsPage } from 'app/api/onboarding-api';
import Exhaust from 'app/components/setup/exhaust';
import features from 'app/common/containers/features';

const { getStringsForPage, getMarkdownStringsForPage, getSectionForPageByIdAndType } =
  contentfulModels;

const mapStateToProps = (state) => {
  const instructionsPage = _.get(state, 'onboarding.instructionsPage');
  return {
    pageStrings: getStringsForPage(instructionsPage),
    pageMarkdownStrings: getMarkdownStringsForPage(instructionsPage),
    nextUrl: `${_.get(state.common, 'features').GFCORE_SITE_URL}/setup/`,
    exhaustPowerArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage, 'set-up-exhaust-power-aura', 'supportArticle',
      ),
    },
    personalFilterArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage, 'personal-filter-aura', 'supportArticle',
      ),
    },
    windowVentingArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage, 'window-venting-aura', 'supportArticle',
      ),
    },
    connectPowerArticle: {
      fields: getSectionForPageByIdAndType(
        instructionsPage, 'connect-power-aura', 'supportArticle',
      ),
    },
  };
};

const preloadContent = ({ dispatch }) => Promise.all([dispatch(fetchInstructionsPage())]);

const ExhaustContainer = connect(mapStateToProps, undefined)(preload(preloadContent)(Exhaust));

export default features(ExhaustContainer);



// WEBPACK FOOTER //
// ./app/containers/setup/exhaust.js